import InputField from "@_common/InputRuleFeild";
import { convertCurrentDateWithTime } from "@_common/date-helpers";
import { handleDownloadOnClick } from "@_common/downloadfile";
import { concatDotToString } from "@_common/text-helpers";
import { getValue } from "@utils/lodash";
import React, { useState } from "react";
import { getFirstLetter } from "@_common/format-text";
import CustomFileUpload from "@_common/custom-file-upload";

function ShowCauseNoticePopup(props: any) {
  const {
    showUpdatePopup,
    setShowUpdatePopup,
    selfCompliance,
    setSelfCompliance,
    handleSubmit,
    submitLoading,
    selectedStatus,
    selectedObj,
    removeDocument,
    //upload
    handleDrop,
    uploadLoading,
    handleDragOver,
    disableUpload,
    handleUploadDocuments,
    uploadedDocuments,
    handleRemoveUploadedFiles,

    request,
    setRequest,

    noticeList,
  } = props;

  return (
    <div
      className={`compelte-task-wrapper add-show-cause-notice-popup ${
        showUpdatePopup ? "compelte-task-wrapper--active" : ""
      }`}
    >
      <div className="compelte-task-wrapper__header d-flex align-items-center justify-content-between">
        <h6 className="compelte-task-wrapper__title">
          Add Show Cause Notice Action
        </h6>
        <img
          src="/images/close-white.svg"
          className="img-fluid navigation-bar-wrapper__close-btn"
          onClick={() => {
            setShowUpdatePopup(false);
          }}
        />
      </div>
      <div className="compelte-task-wrapper__body d-flex add-show-cause-notice-action">
        <div className="compelte-task-wrapper__completion flex-2 compelte-task-wrapper__completion_fixed_button padd-0">
          <div className="complete-task-wrapper__completion-holder pb-0">
            <div className="compelte-task-wrapper__form">
              <div className="common-grid">
                <div className="common-input-grid-item w-100">
                  <div className="common-input-grid-item form-group">
                    <label className="checkpoint-active-details__label ms-0">
                      Notice Status
                    </label>
                    <div className="filter-form-wrappper__location-input">
                      <InputField
                        inputType="INPUT_REACT_SELECT"
                        placeholder="Enter Notice Status"
                        className="form-control w-100"
                        name="status"
                        id="status"
                        options={noticeList}
                        value={noticeList.filter(
                          (item: any) =>
                            item.value === getValue(request, `status`, "")
                        )}
                        onChange={(e: any) =>
                          setRequest({
                            ...request,
                            status: e.value,
                          })
                        }
                        label="Notice Status"
                        // validator={simpleValidator}
                      />
                    </div>
                  </div>
                  <div className="common-input-grid-item form-group w-100">
                    <label className="checkpoint-active-details__label ms-0">
                      Action Taken
                    </label>
                    <div className="filter-form-wrappper__location-input">
                      <InputField
                        inputType="TEXTAREA_COMMON"
                        placeholder="Enter Action Taken"
                        className="form-control w-100"
                        name="action_taken"
                        id="action_taken"
                        value={getValue(request, `action_taken`, "")}
                        onChange={(e: any) =>
                          setRequest({
                            ...request,
                            action_taken: e.target.value,
                          })
                        }
                        label="Action Taken"
                        // validator={simpleValidator}
                      />
                    </div>
                  </div>
                  <div className="common-input-grid-item form-group w-100">
                    <label className="checkpoint-active-details__label ms-0">
                      Next Action Taken
                    </label>
                    <div className="filter-form-wrappper__location-input">
                      <InputField
                        inputType="TEXTAREA_COMMON"
                        placeholder="Enter Next Action Taken"
                        className="form-control w-100"
                        name="next_action_taken"
                        id="next_action_taken"
                        value={getValue(request, `next_action_taken`, "")}
                        onChange={(e: any) =>
                          setRequest({
                            ...request,
                            next_action_taken: e.target.value,
                          })
                        }
                        label="Next Action Taken"
                        // validator={simpleValidator}
                      />
                    </div>
                  </div>

                  <div className="common-input-grid-item form-group w-100">
                    <label className="checkpoint-active-details__label ms-0">
                      Comments
                    </label>
                    <div className="filter-form-wrappper__location-input">
                      <InputField
                        inputType="TEXTAREA_COMMON"
                        placeholder="Enter Comments"
                        className="form-control w-100"
                        name="comments"
                        id="comments"
                        value={getValue(request, `comments`, "")}
                        onChange={(e: any) =>
                          setRequest({
                            ...request,
                            comments: e.target.value,
                          })
                        }
                        label="Comments"
                        // validator={simpleValidator}
                      />
                    </div>
                  </div>
                  
                  <div className="d-flex align-items-center gap form-group mb-0">
                    <div className="common-input-grid-item position-relative">
                      <label className="checkpoint-active-details__label ms-0">
                        Next Due Date
                      </label>
                      <div className="filter-form-wrappper__location-input">
                        <InputField
                          inputType="DATETYPE-DOB"
                          className="release-date-wrapper__vendor-form-control form-control release-date-wrapper__vendor-form-control--calendar"
                          value={
                            getValue(request, `next_due_date`, "")
                              ? new Date(getValue(request, `next_due_date`, ""))
                              : null
                          }
                          onChange={(event: any) =>
                            setRequest({
                              ...request,
                              next_due_date: event,
                            })
                          }
                          placeholderText="Enter Next Due Date"
                        />
                        <img
                          src="/images/calander.svg"
                          className="img-fluid form-image form-image--calender-modal"
                        />
                      </div>
                    </div>
                    <div className="common-input-grid-item position-relative">
                      <label className="checkpoint-active-details__label ms-0">
                        Reminder Date
                      </label>
                      <div className="filter-form-wrappper__location-input">
                        <InputField
                          inputType="DATETYPE-DOB"
                          className="release-date-wrapper__vendor-form-control form-control release-date-wrapper__vendor-form-control--calendar"
                          value={
                            getValue(request, `remainder_date`, "")
                              ? new Date(getValue(request, `remainder_date`, ""))
                              : null
                          }
                          onChange={(event: any) =>
                            setRequest({
                              ...request,
                              remainder_date: event,
                            })
                          }
                          placeholderText="Enter Reminder Date"
                          maxDate={
                            getValue(request, `next_due_date`, "")
                              ? new Date(getValue(request, `next_due_date`, ""))
                              : null
                          }
                        />
                        <img
                          src="/images/calander.svg"
                          className="img-fluid form-image form-image--calender-modal"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <>
            <div className="compelte-task-wrapper__cta d-flex align-items-center">
              <button
                className="ascent-button ascent-button--primary"
                onClick={() => setShowUpdatePopup(false)}
              >
                Cancel
              </button>
              <button
                className="ascent-button ascent-button--secondary"
                onClick={() => handleSubmit()}
                disabled={submitLoading}
              >
                {submitLoading ? "Please wait..." : "Submit"}
              </button>
            </div>
          </>
        </div>
        <div className="compelte-task-wrapper__response flex-1">
          <div className="compelte-task-wrapper__form ">
            <div className="common-input-grid-item">
              <CustomFileUpload
                handleDrop={handleDrop}
                uploadLoading={uploadLoading}
                disableUpload={disableUpload}
                permissions={["update"]}
                handleDragOver={handleDragOver}
                handleUploadDocuments={handleUploadDocuments}
              />
              {getValue(uploadedDocuments, `length`, 0) > 0
                ? uploadedDocuments.map((item: object, key: number) => {
                    return (
                      <div
                        key={key}
                        className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between"
                      >
                        <p
                          className="cursor-pointer"
                          onClick={() =>
                            handleDownloadOnClick(
                              getValue(item, `url`, ""),
                              getValue(item, `name`, "")
                            )
                          }
                        >
                          {getValue(item, `name.length`, "") > 30
                            ? getValue(item, `name`, "")
                                .substring(0, 30)
                                .concat("...")
                            : getValue(item, `name`, "")}
                        </p>
                        {getValue(props, `permissions`, []).includes(
                          "update"
                        ) && (
                          <img
                            src="/images/close-black.svg"
                            className="img-fluid cursor-pointer"
                            onClick={() =>
                              handleRemoveUploadedFiles(
                                getValue(item, `id`, "")
                              )
                            }
                          />
                        )}
                      </div>
                    );
                  })
                : ""}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShowCauseNoticePopup;
